import baseAPI from "@/http";

const router = "api/log/modalchamadapublicalog";

export const modalChamadaPublicaLogAPI = {
  create: modalChamadaPublicaLog =>
    baseAPI.post(router, modalChamadaPublicaLog),
  acessos: filtro => baseAPI.post(router + "/acessos", filtro)
};
